import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en-gb';
import ressourcesFr from './locales/fr';
import ressourcesEn from './locales/en';

/* Traduction de l'interface (FR / EN), pour les homologues anglophones.

   Tant que REACT_APP_I18N_ACTIF ne vaut pas 'true', la langue est forcee en
   francais et le selecteur n'apparait pas : l'application se comporte comme
   avant, meme si un choix 'en' traine dans le navigateur. On l'allume quand
   assez d'ecrans sont traduits pour que l'anglais ne soit pas un melange.

   Pas de detection de la langue du navigateur : un agent dont le poste est en
   anglais basculerait sans l'avoir demande, sur une interface a moitie
   traduite. Seul un choix explicite compte.

   Un espace de noms par dossier de l'application (commun, delais, sinistres...),
   declare dans locales/<langue>/index.js : un test le verifie, ainsi que la
   parite des cles FR/EN. Regles d'ecriture : src/i18n/README.md. */

export const LANGUES = ['fr', 'en'];
export const LANGUE_PAR_DEFAUT = 'fr';
export const CLE_STOCKAGE_LANGUE = 'cbconnect.langue';

// dayjs en anglais britannique : jour/mois/annee et semaine au lundi, comme au
// Ghana et au Nigeria. L'anglais americain inverserait le jour et le mois.
const LOCALE_DAYJS = { fr: 'fr', en: 'en-gb' };

export const ressources = {
  fr: ressourcesFr,
  en: ressourcesEn,
};

// Lu a chaque appel, pas fige au chargement : les tests basculent la variable.
export const i18nActif = () => process.env.REACT_APP_I18N_ACTIF === 'true';

export const langueValide = (langue) => (LANGUES.includes(langue) ? langue : LANGUE_PAR_DEFAUT);

export function langueEnregistree() {
  if (!i18nActif()) return LANGUE_PAR_DEFAUT;
  try {
    return langueValide(window.localStorage.getItem(CLE_STOCKAGE_LANGUE));
  } catch {
    // Stockage bloque (navigation privee stricte) : on reste en francais.
    return LANGUE_PAR_DEFAUT;
  }
}

function appliquerLangue(langue) {
  dayjs.locale(LOCALE_DAYJS[langue] || LOCALE_DAYJS[LANGUE_PAR_DEFAUT]);
  if (typeof document !== 'undefined') document.documentElement.lang = langue;
}

/** Change la langue de l'interface et la retient pour les prochaines visites. */
export async function changerLangue(langue) {
  const retenue = i18nActif() ? langueValide(langue) : LANGUE_PAR_DEFAUT;
  try {
    window.localStorage.setItem(CLE_STOCKAGE_LANGUE, retenue);
  } catch { /* le choix vaudra pour cette visite seulement */ }
  await i18n.changeLanguage(retenue);
  return retenue;
}

// Abonne AVANT l'init, et avant les composants : dayjs doit avoir change de
// langue quand React re-rend, sinon le premier rendu anglais garde des mois
// en francais.
i18n.on('languageChanged', appliquerLangue);

i18n.use(initReactI18next).init({
  resources: ressources,
  lng: langueEnregistree(),
  fallbackLng: LANGUE_PAR_DEFAUT,
  supportedLngs: LANGUES,
  ns: Object.keys(ressources.fr),
  defaultNS: 'commun',
  // React echappe deja le texte qu'il affiche.
  interpolation: { escapeValue: false },
  // Ressources embarquees : init synchrone, le premier rendu est deja traduit.
  initImmediate: false,
  react: { useSuspense: false },
});

export default i18n;
